export const getSearchAttributesToRetrieve = () => ['*', '-tokenizedName', '-tokenizedTagLine', '-summary', '-tags'];